import React, { useState, useEffect, useRef } from "react";
import { connect } from "react-redux";
import { Card, CardTitle, CardText, } from "react-md";
import Chip from "@material-ui/core/Chip";
import AddIcon from "@material-ui/icons/Add";
import PropTypes from "prop-types";

import { MSpinner } from "components/Shared";
import {
  getMultiFactorMethodsForUser,
} from "requests/profile";
import SelectTwoFactorSetup from "components/User/2FA/Setup/SelectTwoFactorSetup";
import VerifyTwoFactorSetup from "components/User/2FA/Setup/VerifyTwoFactorSetup";
import RemoveTwoFactorSetup from "components/User/2FA/Setup/RemoveTwoFactorSetup";

const TwoFactorSettings = (props) => {
  const mounted = useRef(true);
  // Get list of available 2fa methods
  const [multiFactorMethods, setMultiFactorMethods] = useState({ data: [], isFetching: false, error: false });
  // Adding a new two factor method
  const [addMultiFactorMethod, setAddMultiFactorMethod] = useState(false);
  // response from auth server for 2fa setup
  const [multiFactorSetupResponse, setMultiFactorSetupResponse] = useState({ data: null, isFetching: false });
  // Adding a new two factor method
  const [removeMultiFactorMethod, setRemoveMultiFactorMethod] = useState({ data: null, shouldRemove: false });

  const { profile, canAdd, internetUserId } = props;
  const UserId = internetUserId ? internetUserId : profile.internetUserId;

  let getMethodsForUser = () => {
    getMultiFactorMethodsForUser(UserId,
      (s) => setMultiFactorMethods({ data: s.multiFactorUserSettingCollection, isFetching: false, error: false }),
      (s) => setMultiFactorMethods({ data: s, isFetching: false, error: true }), mounted);
  };

  useEffect(() => {
    if (!multiFactorMethods.data.length && !multiFactorMethods.isFetching) {
      getMethodsForUser();
    }
    return () => {
      mounted.current = false;
    };
  }, []);

  let removeMethod = (method) => {
    setRemoveMultiFactorMethod({ data: method, shouldRemove: true });
  };

  let addMethod = () => {
    setAddMultiFactorMethod(true);
  };

  let clearTwoFactorResponse = () => {
    setMultiFactorSetupResponse({ data: null, isFetching: false });
  };

  let getFriendlyName = (name) => {
    switch (name) {
      case "Email a verification code":
        return "Email A Verification Code";
      case "Text a verification code to my phone":
        return "Text A Verification Code";
      case "Code is always 123456":
        return "Code Is Always 123456";
      default:
        break;
    }
  };

  let AvailableVerificationMethods = () => {
    let methods = [];
    const { data, error } = multiFactorMethods;
    if (error) {
      methods.push(
        <Chip
          key="methods-error"
          label={`Unable to modify User's Multi-Factor Verification Settings`}
          color="primary"
          variant="outlined"
        />);
    } else {
      if (data) {
        methods.push(data.filter(s => s.multiFactorMethodConfigured).map(s => (
          <Chip
            key={s.multiFactorMethod}
            label={getFriendlyName(s.multiFactorMethod)}
            color="primary"
            variant="outlined"
            onDelete={() => removeMethod(s.multiFactorMethod)}
          />
        )));
        if (canAdd && data.some(s => !s.multiFactorMethodConfigured)) {
          methods.push(
            <Chip
              key={"Add New Verification Method"}
              label="Add New Verification Method"
              color="secondary"
              variant="outlined"
              onClick={s => addMethod(s)}
              icon={<AddIcon />}
            />
          );
        } else if (!canAdd) {
          methods.push(
            <Chip
              key={"No Verification Methods Available"}
              label="No Verification Methods Available"
              color="secondary"
              variant="outlined"
            />
          );
        }
      }
    }
    return methods;
  };

  if (!multiFactorMethods.data || multiFactorMethods.isFetching) {
    return <MSpinner />;
  }
  return (
    <div className="two-factor">
      <Card className="profile-card mcard card-unnested">
        <CardTitle title="" className="mcard-title">
          <span className="mcard-title-text">Available Verification Methods</span>
        </CardTitle>
        <CardText>
          {<AvailableVerificationMethods />}
        </CardText>
      </Card>

      {addMultiFactorMethod && !multiFactorSetupResponse.data &&
        <SelectTwoFactorSetup
          setDisplayCancelDialog={() => setAddMultiFactorMethod(false)}
          multiFactorMethods={multiFactorMethods}
          multiFactorSetupResponse={multiFactorSetupResponse}
          setMultiFactorSetupResponse={setMultiFactorSetupResponse}
        />
      }
      {multiFactorSetupResponse.data && !removeMultiFactorMethod.shouldRemove &&
        <VerifyTwoFactorSetup
          init={false}
          history={history}
          {...multiFactorSetupResponse}
          clearTwoFactorResponse={clearTwoFactorResponse}
          wrapUpAction={() => {
            clearTwoFactorResponse();
            setAddMultiFactorMethod(false);
            getMethodsForUser();
          }}
        />
      }

      {removeMultiFactorMethod.shouldRemove &&
        <RemoveTwoFactorSetup
          closeRemoveDialog={() => {
            setRemoveMultiFactorMethod({ data: null, shouldRemove: false });
            clearTwoFactorResponse();
            getMethodsForUser();
          }}
          internetUserId={UserId}
          multiFactorMethod={removeMultiFactorMethod.data}
          multiFactorSetupResponse={multiFactorSetupResponse}
          setMultiFactorSetupResponse={setMultiFactorSetupResponse}
        />
      }
    </div>
  );
};

TwoFactorSettings.propTypes = {
  profile: PropTypes.object,
  canAdd: PropTypes.bool,
  internetUserId: PropTypes.number,
};

const mstp = state => ({
  profile: state.user.profile,
});

export default connect(mstp)(TwoFactorSettings);